import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IconsService} from './icons.service';


@NgModule({
            declarations: [],
            imports:      [
              CommonModule
            ]
          })
export class IconsModule {

  constructor(icons: IconsService) {
  }
}
